import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const CloudSensorsPage = lazy(
  () => import('./pages/cloud-sensors/cloud-sensors.page'),
);
const AddCloudSensorsPage = lazy(
  () => import('./pages/add-cloud-sensors/add-cloud-sensors.page'),
);
const ViewCloudSensorsPage = lazy(
  () => import('./pages/view-cloud-sensors/view-cloud-sensors.page'),
);

export const CloudSensorsRoutes = () => {
  return (
    <Routes>
      <Route index element={<CloudSensorsPage />} />
      <Route path="add/:sensorType?" element={<AddCloudSensorsPage />} />
      <Route path="view/:deploymentId" element={<ViewCloudSensorsPage />} />
    </Routes>
  );
};
